/** 与 AppFunctor ttqImageGenerationService.inferRequiresDiagram 保持同步 */
export function inferRequiresDiagram(label: string, summary: string): boolean {
  const text = `${label}\n${summary}`;
  return /图解|作图|坐标|图像|示意图|几何图|数形|平移|网格|表格.*图|绘制|画图|表上|产销平衡|调运|运输表|伏格尔|最小元素|闭回路|位势法|矩阵表|表格法|表上作业|平衡表|运筹表/i.test(text);
}

export function candidateNeedsDiagram(candidate: { label: string; approachSummary: string; requiresDiagram?: boolean }): boolean {
  return Boolean(candidate.requiresDiagram)
    || inferRequiresDiagram(candidate.label, candidate.approachSummary);
}
